// Estrutura centralizada de mensagens de suporte
// Cada item define: assunto, genero (Homem|Mulher), status (Cadastrado|Sem Cadastrado) e a resposta

export const MENSAGENS = [
  {
    assunto: 'Redefinição de senha — instruções enviadas',
    genero: 'Homem',
    status: 'Cadastrado',
    resposta: `Querido irmão,

Obrigada pelo contato. Seu acesso foi liberado. Enviamos para o e-mail informado uma mensagem com seu usuário e senha temporária. Por favor, verifique também a caixa de SPAM/Lixo eletrônico. A senha temporária terá validade de 48 horas. Se precisar de nova senha após esse prazo, envie solicitação para suporte@tpedf.com.br.

Atenciosamente,
Equipe de Tecnologia — TPEDF`,
  },
  {
    assunto: 'Redefinição de senha — instruções enviadas',
    genero: 'Mulher',
    status: 'Cadastrado',
    resposta: `Querida irmã,

Obrigada pelo contato. Seu acesso foi liberado. Enviamos para o e-mail informado uma mensagem com seu usuário e senha temporária. Por favor, verifique também a caixa de SPAM/Lixo eletrônico. A senha temporária terá validade de 48 horas. Se precisar de nova senha após esse prazo, envie solicitação para suporte@tpedf.com.br.

Atenciosamente,
Equipe de Tecnologia — TPEDF`,
  },
  {
    assunto: 'Solicitação de cadastro — procedimento',
    genero: 'Homem',
    status: 'Sem Cadastrado',
    resposta: `Querido irmão,

Obrigada pelo contato. Recebemos sua solicitação, porém não localizamos seu registro em nossa base. A equipe de suporte não está autorizada a cadastrar novos usuários. O procedimento exige que a própria pessoa informe o ancião responsável da congregação, que deverá encaminhar os dados ao encarregado pelo cadastro de novos publicadores, designado para o TPE pelo superintendente de circuito designado por Betel.

Se precisar de orientação, os anciãos da sua congregação estão preparados para te passar mais orientações e providenciar o seu cadastro em nosso sistema. Estou à disposição para ajudar no que for possível.

Atenciosamente,
Equipe de Tecnologia — TPEDF`,
  },
  {
    assunto: 'Solicitação de cadastro — procedimento',
    genero: 'Mulher',
    status: 'Sem Cadastrado',
    resposta: `Querida irmã,

Obrigada pelo contato. Recebemos sua solicitação, porém não localizamos seu registro em nossa base. A equipe de suporte não está autorizada a cadastrar novos usuários. O procedimento exige que a própria pessoa informe o ancião responsável da congregação, que deverá encaminhar os dados ao encarregado pelo cadastro de novos publicadores, designado para o TPE pelo superintendente de circuito designado por Betel.

Se precisar de orientação, os anciãos da sua congregação estão preparados para te passar mais orientações e providenciar o seu cadastro em nosso sistema. Estou à disposição para ajudar no que for possível.

Atenciosamente,
Equipe de Tecnologia — TPEDF`,
  },
];

// Mensagens adicionais: usuário cadastrado que não conseguiu instalar o app
MENSAGENS.push(
  {
    assunto: 'Instalação do aplicativo — não conseguiu instalar',
    genero: 'Homem',
    status: 'Cadastrado',
    resposta: `Querido irmão,

Percebemos que você está cadastrado, mas não conseguiu instalar o aplicativo. Para podermos ajudar melhor, por favor verifique estes pontos básicos e nos informe qual mensagem de erro apareceu ou envie uma captura de tela:

- Sistema operacional: verifique se seu aparelho (Android/iOS) está com a versão mínima suportada.
- Espaço disponível: confirme que há espaço suficiente para baixar e instalar o app.
- Conexão: tente uma rede estável (Wi‑Fi preferencialmente).
- Loja de aplicativos: acesse a Play Store/App Store, então procure pelo aplicativo e tente instalar novamente.
- Permissões: permita o download/instalação e as permissões solicitadas.
- Reinstalar: se já tentou, limpe cache da loja de apps, reinicie o aparelho e tente novamente.

Como baixar o aplicativo:

🍎 Para iPhone (iOS):

O aplicativo já está disponível na loja oficial. Basta abrir a App Store e procurar pelo aplicativo ou clicar no link de download fornecido pela congregação.

🤖 Para Android (Google Play):

Pré-lançamento para dispositivos Android. Siga estes passos com atenção:

- O App só estará público na Play Store em 09 de dezembro.
- ⚠️ Acesso à versão de TESTE: você precisa liberar seu e-mail antes de conseguir baixar.
  1) Entre no grupo indicado pela equipe (clique no link de convite).
  2) Após entrar no grupo, aguarde cerca de 20 minutos para que a equipe libere seu acesso.
  3) Somente após aguardar, acesse o link de download da versão de teste e instale o app.

Se após esses passos o problema persistir, envie para suporte@tpedf.com.br o modelo do aparelho, versão do sistema e uma foto/print do erro. Assim conseguiremos orientar com mais precisão.

Atenciosamente,
Equipe de Tecnologia — TPEDF`,
  },
  {
    assunto: 'Instalação do aplicativo — não conseguiu instalar',
    genero: 'Mulher',
    status: 'Cadastrado',
    resposta: `Querida irmã,

Percebemos que você está cadastrada, mas não conseguiu instalar o aplicativo. Para podermos ajudar melhor, por favor verifique estes pontos básicos e nos informe qual mensagem de erro apareceu ou envie uma captura de tela:

- Sistema operacional: verifique se seu aparelho (Android/iOS) está com a versão mínima suportada.
- Espaço disponível: confirme que há espaço suficiente para baixar e instalar o app.
- Conexão: tente uma rede estável (Wi‑Fi preferencialmente).
- Loja de aplicativos: acesse a Play Store/App Store, então procure pelo aplicativo e tente instalar novamente.
- Permissões: permita o download/instalação e as permissões solicitadas.
- Reinstalar: se já tentou, limpe cache da loja de apps, reinicie o aparelho e tente novamente.

Como baixar o aplicativo:

🍎 Para iPhone (iOS):

O aplicativo já está disponível na loja oficial. Basta abrir a App Store e procurar pelo aplicativo ou clicar no link de download fornecido pela congregação.

🤖 Para Android (Google Play):

Pré-lançamento para dispositivos Android. Siga estes passos com atenção:

- O App só estará público na Play Store em 09 de dezembro.
- ⚠️ Acesso à versão de TESTE: você precisa liberar seu e-mail antes de conseguir baixar.
  1) Entre no grupo indicado pela equipe (clique no link de convite).
  2) Após entrar no grupo, aguarde cerca de 20 minutos para que a equipe libere seu acesso.
  3) Somente após aguardar, acesse o link de download da versão de teste e instale o app.

Se após esses passos o problema persistir, envie para suporte@tpedf.com.br o modelo do aparelho, versão do sistema e uma foto/print do erro. Assim conseguiremos orientar com mais precisão.

Atenciosamente,
Equipe de Tecnologia — TPEDF`,
  }
);

// Mensagem: uso do mesmo e-mail por outro usuário
MENSAGENS.push(
  {
    assunto: 'Credenciais inválidas — nova senha temporária',
    genero: 'Homem',
    status: 'Cadastrado',
    resposta: `Querido irmão,

Identificamos que seu acesso apresentou credenciais inválidas. Para sua segurança, enviaremos uma nova senha temporária para o seu e-mail cadastrado, válida por 48 horas. Ao acessar novamente, você poderá cadastrar uma nova senha — inclusive, se desejar, pode usar a mesma senha que utilizou no primeiro acesso.

Se precisar de ajuda ou não receber o e-mail, por favor nos avise respondendo este contato ou escreva para suporte@tpedf.com.br.

Atenciosamente,
Equipe de Tecnologia — TPEDF`,
  },
  {
    assunto: 'Credenciais inválidas — nova senha temporária',
    genero: 'Mulher',
    status: 'Cadastrado',
    resposta: `Querida irmã,

Identificamos que seu acesso apresentou credenciais inválidas. Para sua segurança, enviaremos uma nova senha temporária para o seu e-mail cadastrado, válida por 48 horas. Ao acessar novamente, você poderá cadastrar uma nova senha — inclusive, se desejar, pode usar a mesma senha que utilizou no primeiro acesso.

Se precisar de ajuda ou não receber o e-mail, por favor nos avise respondendo este contato ou escreva para suporte@tpedf.com.br.

Atenciosamente,
Equipe de Tecnologia — TPEDF`,
  },
  {
    assunto: 'Uso do mesmo e-mail — permitido',
    genero: 'Homem',
    status: 'Cadastrado',
    resposta: `Querido irmão,

Sim. As duas pessoas podem utilizar o mesmo e-mail sem problemas. Cada uma terá nome de usuário e senha diferentes para acessar o aplicativo. Caso seja necessário redefinir a senha de alguma das pessoas, a nova senha será enviada para o e-mail que foi cadastrado.

Atenciosamente,
Equipe de Tecnologia — TPEDF`,
  },
  {
    assunto: 'Uso do mesmo e-mail — permitido',
    genero: 'Mulher',
    status: 'Cadastrado',
    resposta: `Querida irmã,

Sim. As duas pessoas podem utilizar o mesmo e-mail sem problemas. Cada uma terá nome de usuário e senha diferentes para acessar o aplicativo. Caso seja necessário redefinir a senha de alguma das pessoas, a nova senha será enviada para o e-mail que foi cadastrado.

Atenciosamente,
Equipe de Tecnologia — TPEDF`,
  },
  {
    assunto: 'Uso do mesmo e-mail — permitido',
    genero: 'Homem',
    status: 'Sem Cadastrado',
    resposta: `Querido irmão,

Sim. As duas pessoas podem utilizar o mesmo e-mail sem problemas. Cada uma terá nome de usuário e senha diferentes para acessar o aplicativo. Caso seja necessário redefinir a senha de alguma das pessoas, a nova senha será enviada para o e-mail que foi cadastrado.

Atenciosamente,
Equipe de Tecnologia — TPEDF`,
  },
  {
    assunto: 'Uso do mesmo e-mail — permitido',
    genero: 'Mulher',
    status: 'Sem Cadastrado',
    resposta: `Querida irmã,

Sim. As duas pessoas podem utilizar o mesmo e-mail sem problemas. Cada uma terá nome de usuário e senha diferentes para acessar o aplicativo. Caso seja necessário redefinir a senha de alguma das pessoas, a nova senha será enviada para o e-mail que foi cadastrado.

Atenciosamente,
Equipe de Tecnologia — TPEDF`,
  }
);


// Mensagem: como baixar o aplicativo (instruções por plataforma)
// (Removido — as instruções de download foram incorporadas às mensagens de instalação)

// Helpers
export const listarAssuntosPorStatus = (status) => {
  const set = new Set(
    MENSAGENS.filter((m) => m.status === status).map((m) => m.assunto)
  );
  return Array.from(set);
};

export const obterMensagem = ({ status, genero, assunto }) => {
  const match = MENSAGENS.find(
    (m) => m.status === status && m.genero === genero && m.assunto === assunto
  );
  return match ? match.resposta : '';
};
